import React from 'react';
import { SuggestionType } from './useGooglePlaces';
import SelectIcon from '../../assets/icons/SelectIcon';
import {
  Option,
  SuggestionsContainer,
  CheckMarkWrapper,
  BoldText,
} from './AddressAutoComplete.style';

type SuggestionsListProps = {
  suggestions: SuggestionType[];
  focusedOptionIndex: number;
  setFocusedOptionIndex: (value: React.SetStateAction<number>) => void;
  handleSuggestionClick: (suggestion: string) => void;
};

const SuggestionsList: React.FC<SuggestionsListProps> = ({
  suggestions,
  focusedOptionIndex,
  setFocusedOptionIndex,
  handleSuggestionClick,
}) => (
  <SuggestionsContainer>
    {suggestions.map(({ placeId, description, matchedIndex }, index) => (
      <Option
        key={placeId}
        focused={index === focusedOptionIndex}
        onMouseOver={() => setFocusedOptionIndex(index)}
        onClick={() => handleSuggestionClick(placeId)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSuggestionClick(placeId);
          }
        }}
      >
        <CheckMarkWrapper focused={index === focusedOptionIndex}>
          <SelectIcon />
        </CheckMarkWrapper>
        <span>
          {matchedIndex ? (
            <>
              {/* Making the matched substring BOLD */}
              <BoldText>{description.substring(0, matchedIndex)}</BoldText>
              {description.substring(matchedIndex)}
            </>
          ) : (
            description
          )}
        </span>
      </Option>
    ))}
  </SuggestionsContainer>
);

export default SuggestionsList;
